/* eslint-disable */
import React, { memo } from 'react';
import { useRoutes, Outlet } from 'react-router';
// import PageNotFound from '../components/PageNotFound';
import CreateKitchen from '../screens/CreateKitchen';
import ProductStudio from '../screens/Product/ProductStudio';
import DreamKitchen from '../screens/DreamKitchen';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

// eslint-disable-next-line react/prop-types
const NotFound = ({ message }) => {
  return (
    <Box
      height="200px"
      display="flex"
      marginTop="140px"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h1">{message}</Typography>
    </Box>
  );
};

const childrenRoutes = [
  {
    path: ':appliances/product-studio',
    element: <ProductStudio />,
  },
  {
    path: 'dream-kitchen',
    element: <DreamKitchen />,
  },
];

let appRoutes = [
  {
    path: 'northstar',
    element: <CreateKitchen />,
    children: [...childrenRoutes],
  },
  {
    path: 'heritage',
    element: <CreateKitchen />,
    children: [...childrenRoutes],
  },
  {
    path: 'fireview',
    element: <CreateKitchen />,
    children: [
      {
        path: ':appliances/product-studio',
        element: <ProductStudio />,
      },
      {
        path: 'dream-kitchen',
        element: <DreamKitchen />,
      },
    ],
  },
];

const ParentElement = () => <Outlet />;

let dealerRoutes = [
  {
    path: '',
    element: <ParentElement />,
    children: [...appRoutes],
  },
  {
    path: ':dealer',
    element: <ParentElement />,
    children: [...appRoutes],
  },
  {
    path: ':dealer/404',
    element: <NotFound message={'404 Dealer not found!'} />,
    children: [...appRoutes],
  },
];

const Routes = () => {
  return useRoutes([
    ...dealerRoutes,
    {
      path: '*',
      element: <NotFound message={'404 Page not found!'} />,
    },
  ]);
};

export default memo(Routes);
